import React from 'react';
import { useProjectDocs } from '../hooks/useProjectDocs';
import { cn } from '@/utils/cn';
import { ActionMenu } from '@/components/ui/ActionMenu';
import { TablePagination } from '@/components/ui/TablePagination';

export function ProjectDocsList() {
  const { docs, isLoading } = useProjectDocs();

  return (
    <div className="bg-white rounded-md border border-slate-100  overflow-hidden min-h-[600px] flex flex-col">
      <div className="overflow-x-auto flex-1">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/50 text-xs font-normal text-slate-400 border-b border-slate-100">
              <th className="py-3 px-4 w-10 font-normal">
                 <input type="checkbox" className="rounded border-slate-200 text-emerald-600 focus:ring-emerald-500" />
              </th>
              <th className="py-3 px-4 font-normal">Tên tài liệu</th>
              <th className="py-3 px-4 font-normal">Loại tài liệu</th>
              <th className="py-3 px-4 font-normal">Người tải lên</th>
              <th className="py-3 px-4 font-normal">Ngày cập nhật</th>
              <th className="py-3 px-4 font-normal">Kích thước</th>
              <th className="py-3 px-4 w-10 font-normal"></th>
            </tr>
          </thead>
          <tbody className="text-xs lg:text-sm divide-y divide-slate-50">
            {isLoading ? (
              Array.from({ length: 8 }).map((_, i) => (
                <tr key={i} className="animate-pulse">
                  <td colSpan={7} className="p-4"><div className="h-10 bg-slate-50 rounded-md" /></td>
                </tr>
              ))
            ) : (
              docs.map((doc) => (
                <tr key={doc.id} className="hover:bg-slate-50/50 transition-colors group">
                  <td className="py-4 px-4">
                     <input type="checkbox" className="rounded border-slate-200 text-emerald-600 focus:ring-emerald-500" />
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <FileIcon extension={doc.extension} />
                      <div className="flex flex-col min-w-0">
                        <span className="font-normal text-slate-700 truncate">{doc.name}</span>
                        <span className="text-xs text-slate-400">{doc.folder}</span>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <span className={cn(
                      "px-2 py-0.5 rounded-md text-xs font-normal whitespace-nowrap",
                      doc.type === 'Pháp lý' ? 'bg-purple-50 text-purple-600' : 
                      doc.type === 'Thiết kế' ? 'bg-blue-50 text-blue-600' : 'bg-emerald-50 text-emerald-600'
                    )}>
                      {doc.type}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <img src={doc.uploader.avatar} alt="" className="w-6 h-6 rounded-full border border-slate-100" />
                      <span className="font-normal text-slate-600 truncate max-w-[100px]">{doc.uploader.name}</span>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <span className="text-xs font-normal text-slate-500">{doc.updatedAt}</span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="text-xs font-normal text-slate-500">{doc.size}</span>
                  </td>
                  <td className="py-4 px-4 text-right">
                    <ActionMenu 
                      items={[
                        { label: 'Xem chi tiết', onClick: () => {} },
                        { label: 'Tải xuống', onClick: () => {} },
                        { label: 'Di chuyển', onClick: () => {} },
                        { label: 'Xóa', destructive: true, onClick: () => {} }
                      ]} 
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="px-4 border-t border-slate-50 bg-slate-50/30">
        <TablePagination 
          currentPage={1} 
          totalItems={109} 
          pageSize={10} 
          onPageChange={() => {}} 
          itemLabel="tài liệu"
        />
      </div>
    </div>
  );
}

function FileIcon({ extension }: { extension: string }) {
  const iconMap: any = {
    pdf: { color: 'text-rose-500', bg: 'bg-rose-50', icon: 'ri-file-pdf-2-line' },
    docx: { color: 'text-blue-500', bg: 'bg-blue-50', icon: 'ri-file-word-2-line' },
    dwg: { color: 'text-sky-500', bg: 'bg-sky-50', icon: 'ri-file-code-line' },
    xlsx: { color: 'text-emerald-500', bg: 'bg-emerald-50', icon: 'ri-file-excel-2-line' },
    jpg: { color: 'text-amber-500', bg: 'bg-amber-50', icon: 'ri-file-image-line' },
  };

  const style = iconMap[extension] || { color: 'text-slate-400', bg: 'bg-slate-50', icon: 'ri-file-line' };

  return (
    <div className={cn("w-8 h-8 rounded-md flex items-center justify-center shrink-0", style.bg, style.color)}>
       <i className={cn(style.icon, "text-lg")} />
    </div>
  );
}
